import React, { useState } from "react";
import { IconButton, useMediaQuery, useTheme } from "@material-ui/core";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Modal from "../../../../components/modals/Modal";
import { CloseIcon } from "../../../icons";
import { useEntryModalConfig } from "../../NavProvider";
import { useAuth } from "../../AuthProvider";
import { setCookie, getCookie } from "../../../../lib/cookie";
import psl from "../../../../lib/sso/psl";
import { UserSegment } from "../../types";
import { interpolate } from "../../../../lib/utils";
var entryModalCookie = "acm_entry_modal_shown";
var useStyles = makeStyles(function (_a) {
    var _b;
    var breakpoints = _a.breakpoints;
    return createStyles({
        paper: (_b = {
                margin: "auto",
                backgroundColor: "#fff",
                borderRadius: 4,
                overscrollBehavior: "contain",
                width: function (_a) {
                    var width = _a.mobileImg.width;
                    return width;
                },
                maxHeight: function (_a) {
                    var height = _a.mobileImg.height;
                    return height;
                }
            },
            _b[breakpoints.up("md")] = {
                width: function (_a) {
                    var width = _a.desktopImg.width;
                    return width;
                },
                maxHeight: function (_a) {
                    var height = _a.desktopImg.height;
                    return height;
                },
            },
            _b),
        closeIcon: {
            position: "absolute",
            right: 0,
            zIndex: 1,
        },
        anchor: {
            width: "100%",
            zIndex: 0,
        },
        image: {
            display: "block",
            width: "100%",
        },
    });
});
var EntryModal = function () {
    var _a = useState(true), show = _a[0], setShow = _a[1];
    var theme = useTheme();
    var isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    var _b = useEntryModalConfig(), closeIconColor = _b.closeIconColor, image = _b.image, cookieDuration = _b.cookieDuration, applicablePortals = _b.applicablePortals, userSegment = _b.userSegment;
    var name = image.name, url = image.url, mobileImg = image.mobileImg, desktopImg = image.desktopImg;
    var styles = useStyles(image);
    var match = psl(window.location.hostname);
    var domain = match ? "." + match : window.location.hostname;
    var applicable = applicablePortals.find(function (portal) { return window.location.href.match(new RegExp(portal, "i")); });
    var authenticated = useAuth().authenticated;
    var urlWithReplacer = interpolate(url, { location: encodeURIComponent(window.location.href) });
    switch (userSegment) {
        case UserSegment.NonLogin:
            if (authenticated)
                return null;
            break;
        case UserSegment.LoggedIn:
            if (!authenticated)
                return null;
            break;
        case UserSegment.All:
            break;
        default:
            return null;
    }
    if (getCookie(entryModalCookie) || !applicable)
        return null;
    var handleClose = function () { return setShow(false); };
    var handleClick = function () {
        handleExited();
        setShow(false);
    };
    var handleExited = function () { return setCookie(entryModalCookie, 1, cookieDuration, false, domain); };
    return (React.createElement(Modal, { disableBackdropClick: true, id: "acm-header__entry-modal", classes: { paper: styles.paper }, open: show, onClose: handleClose, onExited: handleExited, fullScreen: true },
        React.createElement("div", { className: styles.closeIcon },
            React.createElement(IconButton, { onClick: handleClose, id: "entry-modal-close", disableRipple: true },
                React.createElement(CloseIcon, { color: closeIconColor }))),
        React.createElement("a", { href: urlWithReplacer, className: styles.anchor, onClick: handleClick },
            React.createElement("img", { className: styles.image, src: isDesktop ? desktopImg.image : mobileImg.image, alt: name }))));
};
export default EntryModal;
